import React from 'react';
import {useMutation} from '@tanstack/react-query';
import {getWithdrawalUser} from '../library/api';
import {useNavigate} from 'react-router-dom';
import {useRecoilState, useResetRecoilState, useSetRecoilState} from 'recoil';
import {verifyInfoState} from '../library/recoil/atoms/verifyInfoState';
import {useCookies} from 'react-cookie';

const Withdraw = () => {
    const navigate = useNavigate();
    const resetVerifyInfo = useResetRecoilState(verifyInfoState);

    const [removeCookie] = useCookies(['remember']);

    const {mutate: getWithdrawalUserMutate} = useMutation({
        mutationKey: ['getWithdrawalUser'],
        mutationFn: getWithdrawalUser,
        onSuccess: data => {
            if (data.done) {
                localStorage.setItem('admin_token', '');
                resetVerifyInfo();
                //     resetUserInfo();
                removeCookie('remember');
                navigate('/');
                alert('탈퇴가 완료되었습니다');
            }
        }, onError: error => {
            if (error.response.data.code === 406) {
                alert(error.response.data.message);
            }

            throw error;
        }
    });

    // 탈퇴 버튼 클릭
    const handleSubmit = (event) => {
        event.preventDefault();
        const ag = event.target.ag.checked;
        if (!ag) {
            alert('안내사항을 확인후 체크해주세요');
            return;
        }

        if (!window.confirm('정말로 탈퇴하시겠습니까?')) return;
        getWithdrawalUserMutate();
    };

    return (
        <main className="flex-grow w-full mx-auto px-4 py-8 sm:py-12 bg-[#F7F7F7]">
            <h1 className="text-2xl sm:text-3xl font-bold text-center mt-[16px]">회원탈퇴</h1>
            <p className="text-center mt-2 mb-12">안내사항을 확인해주세요.</p>

            <div className="max-w-[600px] mx-auto bg-white p-6 sm:p-12 rounded-[10px] shadow-md mb-[130px]">
                <form id="withdrawFrom" className="flex flex-col w-full justify-center" onSubmit={handleSubmit}>
                    <h2 className="font-bold mb-5">안내사항</h2>
                    <div className="border-b border-gray-300 mb-7"></div>
                    <ul className="mb-7 pl-4 space-y-2">
                        <li className="list-disc text-sm tracking-[-0.35px]">탈퇴 신청 후 정산 관련 기능을 제외한 파트너스 기능은 사용 할 수
                            없습니다
                        </li>
                        <li className="list-disc text-sm tracking-[-0.35px]">탈퇴 신청일 기준 잔여수익금이 있는 경우 지급이 완료된 후 탈퇴 절차가
                            완료됩니다.
                        </li>
                        <li className="list-disc text-sm tracking-[-0.35px]">탈퇴 신청일 이후 발생하는 수익은 지급받을 수 없습니다.</li>
                        <li className="list-disc text-sm tracking-[-0.35px]">탈퇴 절차가 완료되면 기존 정보 확인은 불가능합니다.</li>
                        <li className="list-disc text-sm tracking-[-0.35px]">탈퇴 절차가 완료된 후 재가입이 가능합니다.</li>
                        <li className="list-disc text-sm tracking-[-0.35px]">탈퇴 신청은 번복 될 수 없습니다.</li>
                    </ul>
                    <div className="border-b border-gray-300 mb-7"></div>
                    <div className="flex items-center">
                        <input type="checkbox" name="ag" id="ag"
                               className="mr-2 w-4 h-4 cursor-pointer rounded-[3px]"/>
                        <p className="text-sm font-semibold">위의 안내사항을 모두 인지하였습니다.</p>
                    </div>
                    <button type="submit"
                            className="mt-12 w-full bg-teal-500 font-bold text-lg text-white py-3 rounded-[30px] hover:bg-teal-600 transition duration-300">탈퇴하기
                    </button>
                </form>
            </div>
        </main>
    );
};

export default Withdraw;
